// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-add-existing-customer-user-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
}
.tenant-administrator-add-existing-customer-user-container{
    margin-bottom: 15vh;
    width: 32vw;
    position: absolute;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    transform: translateX(-100%);
    animation: tenant-administrator-add-existing-customer-user-container-fade-in 1s ease-out forwards;
}
@keyframes tenant-administrator-add-existing-customer-user-container-fade-in {
    from{
        transform: translateX(-100%);
    }
    80%{
        transform: translateX(5%);
    }
    to{
        transform: translateX(0);
    }
}
.tenant-administrator-add-existing-customer-user-header{
    color: white;
    margin: 0px;
    padding: 10px 25px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: 5px  5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-add-existing-customer-user-header h1{
    margin: 0px;
    font-size: 22px;
    font-weight: 600;
    cursor: default;
}
.tenant-administrator-add-existing-customer-user-header p{
    margin: 0px;
    cursor: pointer;
    font-size: 22px;
    font-weight: 400;
}
.tenant-administrator-add-existing-customer-user-body{
    padding: 0px 20px;
}
.tenant-administrator-add-existing-customer-user-selection-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
}
.tenant-administrator-add-existing-customer-user-selection-container select{
    width: 40%;
    margin-bottom: 20px;
    margin-right: 20%;
}
.tenant-administrator-add-existing-customer-user-details-entry-container{
    position: relative;
    margin: 20px 0px;
    padding: 0px 10px;
    padding-top: 4px;
    box-sizing: border-box;
    border-bottom: 1px solid gray;
    border-radius: 2px 2px 0px 0px;
    background-color: rgba(222, 229, 233,0.6);
}
.tenant-administrator-add-existing-customer-user-details-entry-container:focus-within{
    border-bottom: 2px solid rgba(155, 30, 30, 0.952);
}
.tenant-administrator-add-existing-customer-user-details-entry-container.unpadded{
    padding: 0px;
}
.tenant-administrator-add-existing-customer-user-details-entry-container p{
    margin: 4px 2px;
    margin-top: 0px;
    font-size: 14px;
    cursor: default;
}
.tenant-administrator-add-existing-customer-user-details-entry-container .title-p{
    margin: 0px;
    font-size: 12px;
    color: rgb(48, 48, 48);
}
.tenant-administrator-add-existing-customer-user-details-entry-container input{
    width: calc(100% - 20px);
    margin: 0px 10px;
    padding: 4px 0px;
    box-sizing: border-box;
    border: none;
    outline: none;
    background-color: transparent;
}
.tenant-administrator-add-existing-customer-user-details-entry-container.unpadded p{
    margin-left: 10px;
}
.tenant-administrator-add-existing-customer-user-details-entry-container span{
    color: red;
}
.tenant-administrator-add-existing-customer-user-details-entry-container select{
    width: 100%;
    border: none;
    outline: none;
    padding-bottom: 5px;
    background-color: transparent;
}
.tenant-administrator-add-existing-customer-user-selected-customer-user-name-display{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tenant-administrator-add-existing-customer-user-selected-customer-user-name-display .close-p{
    cursor: pointer;
    margin-right: 10px;
    color: rgb(48, 48, 48);
}
.tenant-administrator-add-existing-customer-user-customer-users-browser{
    position: absolute;
    z-index: 1;
    display: none;
    max-height: 13.2vh;
    margin-top: 2px;
    width: 100%;
    overflow: auto;
    background-color: white;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-add-existing-customer-user-customer-users-browser.active{
    display: block;
}
.tenant-administrator-add-existing-customer-user-customer-users-browser::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-add-existing-customer-user-customer-users-browser::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: gray;
}
.tenant-administrator-add-existing-customer-user-customer-users-browser div{
    cursor: pointer;
    padding: 5px 10px;
}
.tenant-administrator-add-existing-customer-user-customer-users-browser div:hover{
    background-color: rgb(229, 232, 233);
}
.tenant-administrator-add-existing-customer-user-customer-users-browser p{
    margin: 0px;
    cursor: pointer;
}

.tenant-administrator-add-existing-customer-user-buttons-container{
    margin: 25px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tenant-administrator-add-existing-customer-user-buttons-container button{
    border: none;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
}
.tenant-administrator-add-existing-customer-user-buttons-container button.cancel{
    font-weight: 500;
    color: rgba(155, 30, 30, 0.952);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-add-existing-customer-user-buttons-container button.add.active{
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in-out;
}

.tenant-administrator-adding-existing-customer-user-container{
    text-align: center;
    padding: 20px 26px;
    border-radius: 5px;
    background-color: white;
}
.tenant-administrator-adding-existing-customer-user-container div{
    width: 32px;
    height: 32px;
    display: inline-block;
    border-radius: 50%;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
    animation: tenant-administrator-adding-existing-customer-user-spinner 0.8s linear infinite;
}
@keyframes tenant-administrator-adding-existing-customer-user-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-adding-existing-customer-user-container p{
    margin: 10px 5px;
    margin-bottom: 0px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}



.tenant-administrator-added-existing-customer-user-container{
    padding: 16px 25px;
    border-radius: 5px;
    background-color: white;
}
.tenant-administrator-added-existing-customer-user-container p{
    margin: 8px 0px;
    margin-bottom: 16px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-added-existing-customer-user-container div{
    text-align: right;
}
.tenant-administrator-added-existing-customer-user-container div button{
    padding: 6px 16px;
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 5px;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/AddExistingCustomerUser.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;AACzC;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;IAC1C,4DAA4D;IAC5D,4BAA4B;IAC5B,iGAAiG;AACrG;AACA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,+BAA+B;IAC/B,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;AAC7C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,2CAA2C;AAC/C;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,4DAA4D;AAChE;AACA;IACI,YAAY;IACZ,0CAA0C;IAC1C,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,6BAA6B;IAC7B,0FAA0F;AAC9F;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,4DAA4D;AAChE;;;;AAIA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,4DAA4D;AAChE;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,0CAA0C;IAC1C,8CAA8C;AAClD","sourcesContent":[".tenant-administrator-add-existing-customer-user-parent-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 100;\r\n    height: 100vh;\r\n    width: 100vw;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n}\r\n.tenant-administrator-add-existing-customer-user-container{\r\n    margin-bottom: 15vh;\r\n    width: 32vw;\r\n    position: absolute;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    transform: translateX(-100%);\r\n    animation: tenant-administrator-add-existing-customer-user-container-fade-in 1s ease-out forwards;\r\n}\r\n@keyframes tenant-administrator-add-existing-customer-user-container-fade-in {\r\n    from{\r\n        transform: translateX(-100%);\r\n    }\r\n    80%{\r\n        transform: translateX(5%);\r\n    }\r\n    to{\r\n        transform: translateX(0);\r\n    }\r\n}\r\n.tenant-administrator-add-existing-customer-user-header{\r\n    color: white;\r\n    margin: 0px;\r\n    padding: 10px 25px;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    box-sizing: border-box;\r\n    border-radius: 5px  5px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.tenant-administrator-add-existing-customer-user-header h1{\r\n    margin: 0px;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n    cursor: default;\r\n}\r\n.tenant-administrator-add-existing-customer-user-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    font-weight: 400;\r\n}\r\n.tenant-administrator-add-existing-customer-user-body{\r\n    padding: 0px 20px;\r\n}\r\n.tenant-administrator-add-existing-customer-user-selection-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0px 20px;\r\n}\r\n.tenant-administrator-add-existing-customer-user-selection-container select{\r\n    width: 40%;\r\n    margin-bottom: 20px;\r\n    margin-right: 20%;\r\n}\r\n.tenant-administrator-add-existing-customer-user-details-entry-container{\r\n    position: relative;\r\n    margin: 20px 0px;\r\n    padding: 0px 10px;\r\n    padding-top: 4px;\r\n    box-sizing: border-box;\r\n    border-bottom: 1px solid gray;\r\n    border-radius: 2px 2px 0px 0px;\r\n    background-color: rgba(222, 229, 233,0.6);\r\n}\r\n.tenant-administrator-add-existing-customer-user-details-entry-container:focus-within{\r\n    border-bottom: 2px solid rgba(155, 30, 30, 0.952);\r\n}\r\n.tenant-administrator-add-existing-customer-user-details-entry-container.unpadded{\r\n    padding: 0px;\r\n}\r\n.tenant-administrator-add-existing-customer-user-details-entry-container p{\r\n    margin: 4px 2px;\r\n    margin-top: 0px;\r\n    font-size: 14px;\r\n    cursor: default;\r\n}\r\n.tenant-administrator-add-existing-customer-user-details-entry-container .title-p{\r\n    margin: 0px;\r\n    font-size: 12px;\r\n    color: rgb(48, 48, 48);\r\n}\r\n.tenant-administrator-add-existing-customer-user-details-entry-container input{\r\n    width: calc(100% - 20px);\r\n    margin: 0px 10px;\r\n    padding: 4px 0px;\r\n    box-sizing: border-box;\r\n    border: none;\r\n    outline: none;\r\n    background-color: transparent;\r\n}\r\n.tenant-administrator-add-existing-customer-user-details-entry-container.unpadded p{\r\n    margin-left: 10px;\r\n}\r\n.tenant-administrator-add-existing-customer-user-details-entry-container span{\r\n    color: red;\r\n}\r\n.tenant-administrator-add-existing-customer-user-details-entry-container select{\r\n    width: 100%;\r\n    border: none;\r\n    outline: none;\r\n    padding-bottom: 5px;\r\n    background-color: transparent;\r\n}\r\n.tenant-administrator-add-existing-customer-user-selected-customer-user-name-display{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.tenant-administrator-add-existing-customer-user-selected-customer-user-name-display .close-p{\r\n    cursor: pointer;\r\n    margin-right: 10px;\r\n    color: rgb(48, 48, 48);\r\n}\r\n.tenant-administrator-add-existing-customer-user-customer-users-browser{\r\n    position: absolute;\r\n    z-index: 1;\r\n    display: none;\r\n    max-height: 13.2vh;\r\n    margin-top: 2px;\r\n    width: 100%;\r\n    overflow: auto;\r\n    background-color: white;\r\n    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);\r\n}\r\n.tenant-administrator-add-existing-customer-user-customer-users-browser.active{\r\n    display: block;\r\n}\r\n.tenant-administrator-add-existing-customer-user-customer-users-browser::-webkit-scrollbar{\r\n    width: 4px;\r\n}\r\n.tenant-administrator-add-existing-customer-user-customer-users-browser::-webkit-scrollbar-thumb{\r\n    border-radius: 5px;\r\n    background-color: gray;\r\n}\r\n.tenant-administrator-add-existing-customer-user-customer-users-browser div{\r\n    cursor: pointer;\r\n    padding: 5px 10px;\r\n}\r\n.tenant-administrator-add-existing-customer-user-customer-users-browser div:hover{\r\n    background-color: rgb(229, 232, 233);\r\n}\r\n.tenant-administrator-add-existing-customer-user-customer-users-browser p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n}\r\n\r\n.tenant-administrator-add-existing-customer-user-buttons-container{\r\n    margin: 25px 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.tenant-administrator-add-existing-customer-user-buttons-container button{\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 8px 20px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    box-sizing: border-box;\r\n}\r\n.tenant-administrator-add-existing-customer-user-buttons-container button.cancel{\r\n    font-weight: 500;\r\n    color: rgba(155, 30, 30, 0.952);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-add-existing-customer-user-buttons-container button.add.active{\r\n    color: white;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: background-color 0.25s ease-in-out;\r\n}\r\n\r\n.tenant-administrator-adding-existing-customer-user-container{\r\n    text-align: center;\r\n    padding: 20px 26px;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n}\r\n.tenant-administrator-adding-existing-customer-user-container div{\r\n    width: 32px;\r\n    height: 32px;\r\n    display: inline-block;\r\n    border-radius: 50%;\r\n    border: 2px solid rgba(155, 30, 30, 0.952);\r\n    border-top-color: transparent;\r\n    animation: tenant-administrator-adding-existing-customer-user-spinner 0.8s linear infinite;\r\n}\r\n@keyframes tenant-administrator-adding-existing-customer-user-spinner {\r\n    from{\r\n        transform: rotate(0deg);\r\n    }\r\n    to{\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n.tenant-administrator-adding-existing-customer-user-container p{\r\n    margin: 10px 5px;\r\n    margin-bottom: 0px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n\r\n\r\n.tenant-administrator-added-existing-customer-user-container{\r\n    padding: 16px 25px;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n}\r\n.tenant-administrator-added-existing-customer-user-container p{\r\n    margin: 8px 0px;\r\n    margin-bottom: 16px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-added-existing-customer-user-container div{\r\n    text-align: right;\r\n}\r\n.tenant-administrator-added-existing-customer-user-container div button{\r\n    padding: 6px 16px;\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: background-color 0.25s ease-in-out;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
